import { FC } from "react";
import { ZomentumEntities } from "@/Contracts";
import {
	SalesActivity,
	ESalesActivityType,
	TaskFormValues,
	MeetingFormValues,
	LogCallFormValues,
	LogEmailFormValues,
	SalesActivityCommentFormValues
} from "@/Contracts/Others/SalesActivity";
import { DrawerProps } from "antd/lib/drawer";
import { FormInstance } from "antd/lib/form";
import {
	IOnlyTaskUIProps,
	ITaskUIProps,
	IOnlyMeetingUIProps,
	IMeetingUIProps,
	IOnlyLogCallUIProps,
	ILogCallUIProps,
	IOnlyLogEmailUIProps,
	ILogEmailUIProps,
	IOnlyCommentUIProps,
	ICommentUIProps
} from "../../../templates/ZDrawers/ZSalesActivities/interface";
export interface IAddAllSalesActivitiesProps {
	readonly entityId?: string;
	readonly entityType?: ZomentumEntities;
	readonly onSubmit?: (
		response?:
			| TaskFormValues
			| MeetingFormValues
			| LogCallFormValues
			| LogEmailFormValues
			| SalesActivityCommentFormValues
	) => void;
	readonly onClose?: () => void;
}

export interface IAddSalesActivityDrawerProps extends DrawerProps {
	readonly isEditMode?: boolean;
	readonly onSubmit?: (
		response: SalesActivity,
		opportunityId?: string
	) => void;
	readonly onClose?: () => void;
}

export type ComponentType =
	| ITaskUIProps
	| IMeetingUIProps
	| ILogCallUIProps
	| ILogEmailUIProps
	| ICommentUIProps;

export type FormUIPropsType =
	| IOnlyTaskUIProps
	| IOnlyMeetingUIProps
	| IOnlyLogCallUIProps
	| IOnlyLogEmailUIProps
	| IOnlyCommentUIProps;

export interface IAddSalesActivityWrapperProps<
	T1 extends ComponentType,
	T2 extends FormUIPropsType
> extends IAddSalesActivityDrawerProps {
	Component: FC<T1>;
	form: FormInstance<any>;
	formUIProps: T2;
	salesActivityType: ESalesActivityType;
}

export enum ClientRequestValues {
	PAGE_SIZE = 50
}
export enum OpportunityRequestValues {
	PAGE_SIZE = 50
}

export const MeetingFormValuesCacheKey = "MEETING_FORM_VALUES";

export type MeetingFormValuesInCache = Partial<MeetingFormValues>;
